export default "__VITE_ASSET__Pl13Njdu__"